/**
 * Enum of screen dialogs
 */
const CONTENT = Object.freeze({
  SEARCH: 'search',
  FILTER: 'filter',
});

export default CONTENT;
